/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import { literal } from '../../util.type';

/**
 * Číselník s animacemi.
 * @enum {'fadeIn' | 'pulse' | 'slideInRight' | 'zoomIn' | 'empty'}
 * @readonly
 */
const TransitionsEnum = {
  Empty: literal('empty'),
  FadeIn: literal('fadeIn'),
  Pulse: literal('pulse'),
  SlideInRight: literal('slideInRight'),
  ZoomIn: literal('zoomIn')
};

export default TransitionsEnum;
